'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /*
                                                                                                                                                                                                                              * @Author: edconstdchen
                                                                                                                                                                                                                              * @Date:   2016-08-15 20:12:12
                                                                                                                                                                                                                              * @Last Modified by: jerryfwang
                                                                                                                                                                                                                              * @Last Modified time: 2020-09-23 12:06:27
                                                                                                                                                                                                                              */


/**
 * 生成夹带url
 * @param  {Object} data
 * @param  {String} data.business 业务名称
 * @param  {String} data.docId
 * @param  {Number} [data.dataSrc] 文章来源ID
 * @param  {String} [data.url] 文章原网址
 * @param  {String} [data.tabId]
 * @param  {String} [data.tagId]
 * @param  {String} [data.ch]
 * @return {String}
 */
function buildAttachUrl(_ref) {
  var business = _ref.business,
      env = _ref.env,
      rest = _objectWithoutProperties(_ref, ['business', 'env']);

  var base = 'https://news' + (env !== 'test' ? '' : '.sparta') + '.html5.qq.com/attach?';

  return base + _queryString2.default.stringify(rest);
}

exports.default = buildAttachUrl;